// Auto-generated by scripts/split_ui.js from data/zikirUtama.js — do not edit.
export const ZIKIR_UI = {
  "pageTitle": {
    "id": "Zikir Utama",
    "en": "Main Dhikr",
    "ar": "الأذكار الرئيسية",
    "fr": "Dhikr Principal",
    "de": "Hauptdhikr",
    "es": "Dhikr Principal",
    "ru": "Главный зикр",
    "zh": "主要迪克尔",
    "ja": "メインのズィクル",
    "ko": "주요 지크르",
    "hi": "मुख्य ज़िक्र"
  },
  "pageSub": {
    "id": "Zikir ringan yang mudah diamalkan namun berpahala sangat besar, sesuai tuntunan Al-Qur'an & Sunnah Nabi ﷺ.",
    "en": "Light dhikr that is easy to practice yet carries immense reward, in accordance with the guidance of the Qur'an & the Sunnah of the Prophet ﷺ.",
    "ar": "أذكار خفيفة سهلة المداومة عليها وأجرها عظيم، وفق هدي القرآن الكريم وسنة النبي ﷺ.",
    "fr": "Des dhikr légers, faciles à pratiquer mais d'une grande récompense, conformément aux enseignements du Coran et de la Sunnah du Prophète ﷺ.",
    "de": "Leichter Dhikr, der einfach zu praktizieren ist, aber einen immensen Lohn trägt, gemäß der Anleitung des Qur'an und der Sunnah des Propheten ﷺ.",
    "es": "Dhikr ligero, fácil de practicar pero de gran recompensa, de acuerdo con la guía del Corán y la Sunnah del Profeta ﷺ.",
    "ru": "Лёгкий зикр, который легко практиковать, но несёт огромную награду, в соответствии с руководством Корана и Сунны Пророка ﷺ.",
    "zh": "轻松易行却回报丰厚的迪克尔，遵循《古兰经》与先知ﷺ圣行的指引。",
    "ja": "実践しやすく、しかし非常に大きな報奨をもたらす軽いズィクルであり、クルアーンと預言者ﷺのスンナの導きに従っています。",
    "ko": "실천하기 쉽지만 매우 큰 보상을 가져다주는 가벼운 지크르로, 꾸란과 예언자 ﷺ의 순나의 가르침에 따른 것입니다.",
    "hi": "हल्का ज़िक्र जो आसानी से अमल किया जा सकता है लेकिन बहुत बड़ा सवाब रखता है, क़ुरआन और नबी ﷺ की सुन्नत की रहनुमाई के अनुसार।"
  },
  "dashLabel": {
    "id": "Zikir Utama",
    "en": "Main Dhikr",
    "ar": "الأذكار الرئيسية",
    "fr": "Dhikr Principal",
    "de": "Hauptdhikr",
    "es": "Dhikr Principal",
    "ru": "Главный зикр",
    "zh": "主要迪克尔",
    "ja": "メインのズィクル",
    "ko": "주요 지크르",
    "hi": "मुख्य ज़िक्र"
  },
  "dashHint": {
    "id": "Amalan ringan berpahala besar sesuai sunnah",
    "en": "Light deeds of great reward in accordance with the Sunnah",
    "ar": "أعمال خفيفة ذات أجر عظيم وفق السنة النبوية",
    "fr": "Actes légers à grande récompense conformément à la Sunnah",
    "de": "Leichte Taten mit großem Lohn gemäß der Sunnah",
    "es": "Actos ligeros de gran recompensa conforme a la Sunnah",
    "ru": "Лёгкие деяния с великой наградой согласно Сунне",
    "zh": "遵循圣行、轻松易行却回报丰厚的善功",
    "ja": "スンナに従った、軽くて大きな報奨をもたらす行い",
    "ko": "순나에 따른 작은 실천으로 큰 보상을 얻는 아말",
    "hi": "सुन्नत के अनुसार बड़े सवाब वाले हल्के अमल"
  },
  "meaningLabel": {
    "id": "Arti",
    "en": "Meaning",
    "ar": "المعنى",
    "fr": "Signification",
    "de": "Bedeutung",
    "es": "Significado",
    "ru": "Значение",
    "zh": "含义",
    "ja": "意味",
    "ko": "의미",
    "hi": "अर्थ"
  },
  "virtueLabel": {
    "id": "Keutamaan",
    "en": "Virtue",
    "ar": "الفضيلة",
    "fr": "Vertu",
    "de": "Tugend",
    "es": "Virtud",
    "ru": "Достоинство",
    "zh": "美德",
    "ja": "功徳",
    "ko": "덕목",
    "hi": "फ़ज़ीलत"
  },
  "sourceLabel": {
    "id": "Dalil",
    "en": "Source",
    "ar": "المصدر",
    "fr": "Source",
    "de": "Quelle",
    "es": "Fuente",
    "ru": "Источник",
    "zh": "来源",
    "ja": "出典",
    "ko": "출처",
    "hi": "स्रोत"
  },
  "practiceBtn": {
    "id": "Amalkan di Tasbih",
    "en": "Practice on Tasbih",
    "ar": "طبِّق على السبحة",
    "fr": "Pratiquer sur le Tasbih",
    "de": "Auf dem Tasbih üben",
    "es": "Practicar en el Tasbih",
    "ru": "Практиковать на Тасбихе",
    "zh": "在念珠上练习",
    "ja": "タスビーフで実践する",
    "ko": "타스비흐로 실천하기",
    "hi": "तस्बीह पर अभ्यास करें"
  },
  "countLabel": {
    "id": "Anjuran",
    "en": "Recommendation",
    "ar": "العدد المستحب",
    "fr": "Recommandation",
    "de": "Empfehlung",
    "es": "Recomendación",
    "ru": "Рекомендация",
    "zh": "建议次数",
    "ja": "推奨回数",
    "ko": "권장 횟수",
    "hi": "अनुशंसा"
  },
  "timesUnit": {
    "id": "kali/hari",
    "en": "times/day",
    "ar": "مرة/يوم",
    "fr": "fois/jour",
    "de": "Mal/Tag",
    "es": "veces/día",
    "ru": "раз/день",
    "zh": "次/天",
    "ja": "回/日",
    "ko": "회/일",
    "hi": "बार/दिन"
  },
  "anytime": {
    "id": "Bebas — perbanyaklah",
    "en": "No limit — recite as much as possible",
    "ar": "لا حدَّ — أكثِر منه ما استطعت",
    "fr": "Illimité — récitez-en le plus possible",
    "de": "Unbegrenzt — so oft wie möglich",
    "es": "Sin límite — recita tanto como puedas",
    "ru": "Без ограничений — повторяй как можно больше",
    "zh": "不限次数 — 尽量多诵",
    "ja": "制限なし — できるだけ多く唱えましょう",
    "ko": "제한 없음 — 최대한 많이 낭송하세요",
    "hi": "कोई सीमा नहीं — जितना हो सके उतना पढ़ें"
  },
  "shareBtn": {
    "id": "Bagikan",
    "en": "Share",
    "ar": "مشاركة",
    "fr": "Partager",
    "de": "Teilen",
    "es": "Compartir",
    "ru": "Поделиться",
    "zh": "分享",
    "ja": "シェアする",
    "ko": "공유하기",
    "hi": "साझा करें"
  },
  "playBtn": {
    "id": "Dengarkan",
    "en": "Listen",
    "ar": "استمع",
    "fr": "Écouter",
    "de": "Anhören",
    "es": "Escuchar",
    "ru": "Слушать",
    "zh": "收听",
    "ja": "聴く",
    "ko": "듣기",
    "hi": "सुनें"
  },
  "shareText": {
    "id": "Zikir pilihan dari aplikasi Manasik — Panduan Umrah & Haji ✨",
    "en": "Selected Dhikr from the Manasik app — Umrah & Hajj Guide ✨",
    "ar": "أذكار مختارة من تطبيق المناسك — دليل العمرة والحج ✨",
    "fr": "Dhikr sélectionné depuis l'application Manasik — Guide de la Umrah et du Hajj ✨",
    "de": "Ausgewählter Dhikr aus der Manasik-App — Umrah- & Hajj-Leitfaden ✨",
    "es": "Dhikr seleccionado de la aplicación Manasik — Guía de Umrah y Hajj ✨",
    "ru": "Избранный Зикр из приложения Manasik — Путеводитель по Умре и Хаджу ✨",
    "zh": "来自 Manasik 应用的精选迪克尔 — 副朝与朝觐指南 ✨",
    "ja": "Manasikアプリからの厳選ズィクル — ウムラ＆ハッジガイド ✨",
    "ko": "Manasik 앱의 엄선된 지크르 — 우므라 & 하지 가이드 ✨",
    "hi": "Manasik ऐप से चुने गए ज़िक्र — उमराह और हज गाइड ✨"
  }
};
